import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from '../../assets/close.svg';
import { Form } from "./components/Form";
import { OnlyTransferContactModalProps } from "./types";

export function OnlyTransferContactModal({ isOpen, onRequestClose, contact }: OnlyTransferContactModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content fixed-height"
      style={{ 
        content: { 
          width: '90vw',
          maxWidth: '800px',
          height: '50vh',
          maxHeight: '90vh',
          margin: 'auto',
          overflowY: 'auto',
          padding: '20px'
        } 
      }}
    >
      <button
        type="button"
        onClick={onRequestClose}
        className="react-modal-close"
      >
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>

      <div>
        <ModalTitle>Apenas transferir {contact.name ? `"${contact.name}"` : 'contato'}</ModalTitle>
        <Form onRequestClose={onRequestClose} contact={contact} />
      </div>
    </Modal>
  );
}
